export default {
  section: 'mt-[24px] flex flex-col p-[20px]',
  header: 'bg-[#F0F3F6] rounded-[4px] py-[6px] px-[10px]',
  title: 'text-[16px] font-[500] text-[#585D69] uppercase',
};
